module.exports = __webpack_public_path__ + "question_70x70.20e797e19a83c6e699d811561b53eb51.png";